import PositionPendingAction from "./PositionPendingAction.js";
export default {
  install(molten) {
    molten.addPlugin('Action', PositionPendingAction);
  }
};